import { render, staticRenderFns } from "./AddPlaces.vue?vue&type=template&id=208e1d9c&scoped=true&"
import script from "./AddPlaces.vue?vue&type=script&lang=js&"
export * from "./AddPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e1d9c",
  null
  
)

export default component.exports